import ReadMoreDocsLink from "components/ReadMoreDocsLink";
import Banner from "ds/components/Banner";
import Box from "ds/components/Box";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import FeedbackActions from "ds/components/Feedback/Actions";
import FormField from "ds/components/Form/Field";
import { Commit, VcsProvider } from "types/generated";
import { getDocsUrl } from "utils/getDocsUrl";
import { withTestId } from "utils/withTestId";

import StackRunsPushCommitsDrawerCommit from "./Commit";

type StackRunsPushCommitsDrawerProps = {
  commits: string[];
  headCommit: Pick<Commit, "hash" | "url">;
  provider: VcsProvider;
};

const StackRunsPushCommitsDrawer = createDrawer(
  ({ commits, headCommit, provider }: StackRunsPushCommitsDrawerProps) => {
    return (
      <DrawerSimple {...withTestId("stack-runs-push-commits-drawer")}>
        <DrawerHeader justify="between">
          <DrawerHeaderTitle title="All push commits" />
          <DrawerCloseIcon />
        </DrawerHeader>
        <DrawerBody gap="x-large">
          <Banner variant="info">
            {`This push bundled ${commits.length} commits. Runs are triggered on the HEAD commit.`}
            <FeedbackActions>
              <ReadMoreDocsLink docsUrl={getDocsUrl("/concepts/run/tracked")} />
            </FeedbackActions>
          </Banner>

          <FormField label="Commits" noMargin>
            <Box direction="column" gap="medium">
              {commits.map((sha) => (
                <StackRunsPushCommitsDrawerCommit
                  key={sha}
                  sha={sha}
                  headCommit={headCommit}
                  provider={provider}
                />
              ))}
            </Box>
          </FormField>
        </DrawerBody>
      </DrawerSimple>
    );
  }
);

export const showStackRunsPushCommitsDrawer = createDrawerTrigger(StackRunsPushCommitsDrawer);
